import image from 'assets/images/device/withdraw/image.png';
import DeviceImage from './DeviceImage';

const Withdraw = () => {
  return (
    <div id={'device-withdraw'}>
      <DeviceImage src={image} left={27} top={24} width={375} height={824} />
    </div>
  );
};

export default Withdraw;
